
import { useState } from "react";
import { Button } from "@/components/ui/button";

interface ImageGalleryProps {
  images: string[];
  productName: string;
  showVPXLogos?: boolean;
  applicationDiagram?: string;
}

export const ImageGallery = ({ images, productName, showVPXLogos = false, applicationDiagram }: ImageGalleryProps) => {
  // Combine product images with application diagram if present
  const allImages = applicationDiagram ? [...images, applicationDiagram] : images;
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  // Check if this product has multiple views (at least 2 images)
  const hasMultipleViews = allImages && allImages.length >= 2;

  const threeLogos = [
    "/lovable-uploads/06fe1782-824d-4c1d-9254-aab5065810bf.png", // Dante
    "/lovable-uploads/dc50d6e6-ebe6-4761-a9a7-4221a9044168.png", // AURACAST
    "/lovable-uploads/67aa6f30-ffde-42a8-b227-d61c7af63ddc.png"  // AES
  ];

  return (
    <div className="space-y-4">
      {/* Main image display */}
      <div className="relative aspect-[16/9] w-full overflow-hidden rounded-lg bg-background/50">
        {allImages && allImages.length > 0 ? (
          <div className="flex h-full w-full items-center justify-center">
            <img
              src={allImages[selectedImageIndex]}
              alt={`${productName} - View ${selectedImageIndex + 1}`}
              className="h-full w-full object-contain p-4"
            />
          </div>
        ) : (
          <div className="flex h-full w-full items-center justify-center">
            <img
              src={"/placeholder.svg"}
              alt={productName}
              className="h-full w-full object-contain p-4"
            />
          </div>
        )}
      </div>
      
      {/* Thumbnail navigation for multiple images with logos */}
      {hasMultipleViews && (
        <div className="flex items-center gap-4">
          {/* Thumbnail buttons */}
          <div className="flex gap-2 overflow-x-auto pb-2">
            {allImages.map((image, index) => (
              <Button
                key={index}
                variant={selectedImageIndex === index ? "default" : "outline"}
                className="h-20 w-20 p-1"
                onClick={() => setSelectedImageIndex(index)}
              >
                <img
                  src={image}
                  alt={`${productName} thumbnail ${index + 1}`}
                  className="h-full w-full object-contain"
                />
              </Button>
            ))}
          </div>

          {/* Two logos to the right of thumbnails - Dante and AES for VPX and DIDO products */}
          {showVPXLogos && (
            <div className="flex items-center gap-4 ml-4">
              <div className="w-16 h-12 flex items-center justify-center">
                <img src={threeLogos[0]} alt="Dante Logo" className="max-w-full max-h-full object-contain" />
              </div>
              <div className="w-12 h-10 flex items-center justify-center">
                <img src={threeLogos[2]} alt="AES Logo" className="max-w-full max-h-full object-contain" />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
